import { render, staticRenderFns } from "./NotificationsPanel.vue?vue&type=template&id=3eceeed9&scoped=true"
import script from "./NotificationsPanel.vue?vue&type=script&lang=ts"
export * from "./NotificationsPanel.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsPanel.vue?vue&type=style&index=0&id=3eceeed9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eceeed9",
  null
  
)

export default component.exports